import React from "react"

export default function GithubButton() {
  return (
    <a
      href="https://github.com/keldaanCommunity/pokemonAutoChess"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button type="button" className="bubbly">
        Github
      </button>
    </a>
  )
}
